import React, { useState } from 'react'
import { ErrorMessage, LabelBold } from '../../../design-system/typography'
import ImageIcon from '../../../svgs/ImageIcon'
import {
  FileInput,
  ImagePlaceholder,
  ImagePreview,
  UploadButton,
} from './style'

type ImageUploaderProps = {
  defaultImageUrl?: string
  setImage: (img) => void
  requiredError?: boolean
}

function HeaderImageUploader({
  defaultImageUrl,
  setImage,
  requiredError,
}: ImageUploaderProps) {
  const [preview, setPreview] = useState(defaultImageUrl)

  const uploadImage = (e) => {
    const [file] = e.target.files
    if (!file) {
      setPreview(null)
    } else {
      const url = URL.createObjectURL(file)
      setPreview(url)
      setImage(file)
    }
  }

  return (
    <div>
      <LabelBold>Add header image</LabelBold>
      {preview ? (
        <>
          <ImagePreview alt="Thumbnail image" src={preview} />
          <UploadButton>
            <FileInput type="file" accept="image/ong" onChange={uploadImage} />
            Upload new
          </UploadButton>
        </>
      ) : (
        <>
          <ImagePlaceholder>
            <ImageIcon />
          </ImagePlaceholder>
          <UploadButton type="button">
            <FileInput type="file" accept="image/png" onChange={uploadImage} />
            Upload image
          </UploadButton>
          {requiredError && <ErrorMessage>Required</ErrorMessage>}
        </>
      )}
    </div>
  )
}
export default HeaderImageUploader
